import React, { useContext, useEffect, useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import {useCookies} from 'react-cookie';
import axios from 'axios';
import { base_url } from '../../url_variables';
import { TostMessageContext } from "../../context/TostMessage";
import ReactLoading from 'react-loading';
import { FaCalendarAlt, FaUser, FaSignOutAlt, FaChild, FaCheckCircle } from "react-icons/fa";
import { FaUsersBetweenLines, FaMoneyBillTrendUp } from 'react-icons/fa6';
import { IoMdChatboxes } from "react-icons/io";
import { AiOutlineClockCircle } from "react-icons/ai";
import { HiOutlineBookOpen } from "react-icons/hi";
import { MdOutlineDashboard, MdLanguage } from "react-icons/md";
import { SideMenu } from '../../components/sidebar';
import { TopBar } from '../../components/topbar';
import {ButtonBlack, ButtonSmall} from '../../components/buttons';
import { RouteDisplay } from '../../components/route_display';
import { UserContext } from '../../context/UserContext';
import User from '../../images/user.jpg';
import { IoLibraryOutline } from 'react-icons/io5';
import ProgressBarComponent from '../../components/progess_bar'
import { ClockLoader } from 'react-spinners';
import { FcCancel } from "react-icons/fc";

function ChildProfileScreen() {
    const navigate = useNavigate();
    const [cookies] = useCookies();
    const [loadingClasses, setLoadingClasses] = useState(false);
    const [enrolledClasses, setEnrolledClasses] = useState([]);
    const { setTostMessage } = useContext(TostMessageContext);
    const {logOutFunction, calendarValues, setCalendarValues, userProfile} = useContext(UserContext);
    const [profileData, setProfileData] = useState({ 'f_name': '', 'l_name': '', 'm_name': '', 'streak': '', 'dob': '', 'classes': [], 'attendance': 0 });
    // const [updateTutorAccount, setUpdateTutorAccount] = useState({ bank_code: '', bank_name: '', account_number: '',  })
    const location = useLocation();

    useEffect(() => {
        getClasses();
    }, [])

    const getClasses = async () => {
        setLoadingClasses(true);
        const formData = new FormData();
        formData.append('student_id', location.state.student_id)
        try {
            const response = await axios.post(base_url + '/profile/child-profile.php', formData,{
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: cookies?.userProfile?.session,
                    main_id: cookies?.userProfile?.main_id,
                    sub_id: cookies?.userProfile?.sub_id
                },
            });
            if (response.data.code == 403) {
                setLoadingClasses(false);
                setTostMessage({
                    messageType: "error",
                    message: response.data.response,
                });
                logOutFunction()
            }
            if (response.data.status) {
                setLoadingClasses(false);
                setProfileData({'full_name': response.data.results.first_name + ' ' + response.data.results.middle_name + ' ' + response.data.results.last_name, 'date_joined': response.data.results.date_joined, 'parent': response.data.results.parent, 'no_of_attended': response.data.results.no_of_attended, 'no_of_scheduled': response.data.results.no_of_scheduled, 'parent_contact': response.data.results.parent_contact, 'no_of_tasks_assigned': response.data.results.no_of_tasks_assigned, 'no_of_tasks_started': response.data.results.no_of_tasks_started, 'no_of_enrolled_total': response.data.results.no_of_enrolled_total, 'no_of_enrolled_private_total': response.data.results.no_of_enrolled_private_total, 'total_spent': response.data.results.total_spent, 'dob': response.data.results.dob, 'classes': response.data.results.active_classes_enrrolled, 'attendance': response.data.results.attendance, 'tutor_account_set': response.data.results.tutor_account_set, 'tutor_account_details': response.data.results.tutor_account_details });
            } else {
                setLoadingClasses(false);
                setTostMessage({
                    messageType: "error",
                    message: response.data.response,
                });
            }
        } catch (error) {
            setLoadingClasses(false);
            setTostMessage({
                messageType: "error",
                message: 'Network error',
            });
        }
    }

  return (
    <div className="relative h-screen h-full">
        <div className="flex h-screen bg-white">
            {/* Sidebar */}
            <SideMenu />
            {/* Main content */}
            <main className="flex-1 p-8 overflow-y-auto">
                {/* Header */}
                <TopBar />
                <RouteDisplay />
                <div className='w-full flex flex-row justify-between'>
                    {loadingClasses ? (
                        <div className='flex justify-center items-center w-fill-available h-full z-[999999] bg-[#ffffff] opacity-[0.6] fixed top-0'>
                            <ClockLoader
                                color={'#F4D00F'}
                                loading={loadingClasses}
                                size={60}
                                aria-label="Loading Spinner"
                                data-testid="loader1"
                            />
                        </div>
                    ) : (
                    <div className="w-full lg:w-[70%] p-0 lg:p-6 space-y-6 min-h-screen">
                        <div className="max-w-5xl mx-auto p-0 space-y-8">
                            {/* Personal Details */}
                            <div className="bg-white shadow rounded-xl p-6 space-y-4 border border-1 border-[#bbb]">
                                <h2 className="text-lg font-semibold text-gray-700">Personal Details</h2>
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm text-dark">
                                <div>
                                    <span className="font-medium">Full Name:</span> {profileData?.full_name}
                                </div>
                                <div>
                                    <span className="font-medium">Date of Birth:</span> {profileData?.dob}
                                </div>
                                <div>
                                    <span className="font-medium">Parent:</span> {profileData?.parent}
                                </div>
                                <div>
                                    <span className="font-medium">Parent Contact:</span> {profileData?.parent_contact}
                                </div>
                                <div>
                                    <span className="font-medium">Joined:</span> {profileData?.date_joined}
                                </div>
                                </div>
                            </div>
                            <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                                <div  className="flex flex-row gap-x-2 p-4 items-center justify-start bg-white shadow rounded-xl p-4 py-6 text-center border border-1 border-[#bbb]">
                                    <div className='bg-gradient-to-r from-dark to-yellow rounded-full p-4 bg-[#ff0000] mr-4'>
                                        <FaUsersBetweenLines size={20} color='#fff' />
                                    </div>
                                    <div className='flex flex-col justify-start items-start'>
                                        <div className="text-[12px] font-semibold text-dark">{'Group Classes'}</div>
                                        <div className="text-[25px] font-semibold text-yellow">{profileData?.no_of_enrolled_total}</div>
                                    </div>
                                </div>
                                <div  className="flex flex-row p-4 items-center justify-start bg-white shadow rounded-xl p-4 py-6 text-center border border-1 border-[#bbb]">
                                    <div className='bg-gradient-to-r from-dark to-yellow rounded-full p-4 bg-[#ff0000] mr-4'>
                                        <FaChild size={20} color='#fff' />
                                    </div>
                                    <div className='flex flex-col justify-start items-start'>
                                        <div className="text-[12px] font-semibold text-dark">{'Private Classes'}</div>
                                        <div className="text-[25px] font-semibold text-yellow">{profileData?.no_of_enrolled_private_total}</div>
                                    </div>
                                </div>
                                <div  className="flex flex-row p-4 items-center justify-start bg-white shadow rounded-xl p-4 py-6 text-center border border-1 border-[#bbb]">
                                    <div className='bg-gradient-to-r from-dark to-yellow rounded-full p-4 bg-[#ff0000] mr-4'>
                                        <FaMoneyBillTrendUp size={20} color='#fff' />
                                    </div>
                                    <div className='flex flex-col justify-start items-start'>
                                        <div className="text-[12px] font-semibold text-dark">{'Amount Spent'}</div>
                                        <div className="text-[25px] font-semibold text-yellow">{userProfile?.admin_role == "super-admin" ? profileData?.total_spent : '****'}</div>
                                    </div>
                                </div>
                            </div>
                        
                            {/* Assigned Classes */}
                            <div className="bg-white shadow rounded-xl p-6 space-y-4 border border-1 border-[#bbb]">
                                <h2 className="text-lg font-semibold text-gray-700">Currently Enrolled Classes</h2>
                                <div className="list-disc list-inside flex flex-row flex-wrap gap-1 w-full text-sm text-gray-700 space-y-1">
                                    {profileData?.classes?.map((lang, index) => (
                                        <div className='p-3 bg-gray-100 rounded-[10px] border text-dark w-[fit-content] flex flex-col' key={index}>
                                            <a className='font-semibold'>{lang.class} - {lang.attendance} attendance</a>
                                            <a>{lang.attended} of {lang.scheduled} attended</a>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            {/* Withdrawal Account */}
                            <div className="bg-white shadow rounded-xl p-6 space-y-4 border border-1 border-[#bbb]">
                                <div className='w-full flex flex-row justify-between items-center'>
                                    <h2 className="text-lg font-semibold text-gray-700">Tasks</h2>
                                    <div className='flex flex-row items-center gap-x-2'>
                                        <FaCheckCircle size={20} color='#000aff' />
                                        <label className='text-sm text-[#000aff]'>Participated in {profileData?.no_of_tasks_started} of {profileData?.no_of_tasks_assigned}</label>
                                    </div>
                                </div>
                            </div>
                            </div>
                    </div>
                    )}
                </div>
            </main>
        </div>
    </div>
  );
}

export default ChildProfileScreen;
